import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation('landingPage')

  return (
    <footer className='px-4 pb-8 space-y-4'>
      <div className='space-y-2 text-center'>
        <a
          className='text-mi-bg-primary text-sm flex items-center justify-center'
          href={t('footer.manualUrl')}
          target='_blank'
          rel='noreferrer noopener'
        >
          <OpenInNewIcon className='w-5 h-5 inline-block mr-1' />
          {t('footer.manualLink')}
        </a>
      </div>
    </footer>
  )
}
